import directives from './module';
import {Utils} from 'underscore-extensions';

directives.directive('fixedTabs', () => {
        return (scope: any, element: ng.IAugmentedJQuery) => {
            const header   = element[0];
            let offset: number;
            scope.fixedTab = false;

            setTimeout(() => {
                offset = header.offsetTop;
            }, 0);

            Utils.scopedEvent('resize', scope, _.throttle(() => {
                offset = header.offsetTop || offset;
            }, 100));

            Utils.scopedEvent('scroll', scope, _.throttle(() => {
                Utils.rAF(() => {
                    const atBottom = ((window.scrollY || window.pageYOffset) - offset) > -55;
                    if (scope.fixedTab && !atBottom) {
                        scope.fixedTab = false;
                        header.classList.remove('fixed-tabs--pinned');
                    } else if (!scope.fixedTab && atBottom) {
                        scope.fixedTab = true;
                        header.classList.add('fixed-tabs--pinned');
                    }
                });
            }, 100));
        };
    }
);



// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/FixedTabs.ts